import { DefaultUser } from 'constants/defaultValues';
import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions(
  {
    fetchOrganizations: [],
    fetchOrganizationsSuccess: ['organizations'],
    setOrganizationsLoading: ['isOrganizationsLoading'],
    setChangePassword: ['participantId', 'password'],
    setChangePasswordLoading: ['isChangePasswordLoading'],
    setCreateUser: ['values'],
    setCreateUserLoading: ['isCreateUserLoading'],
    setChangePasswordOk: ['changePasswordOk'],
    setCreateUserOk: ['createUserOk'],
    setUserErrors: ['error'],
    fetchTags: ['tags'],
    fetchTagsSuccess: ['tags'],
    setLastLogin: ['userId'],
    setUsersIsLoading: ['isUsersLoading'],
    setAuthenticatedUser: ['authenticatedUser'],
    setAuthenticatedUserSuccess: ['authenticatedUser'],
    fetchAuthenticatedUsers: [],
    fetchAuthenticatedUsersSuccess: [
      'authenticatedUsers',
      'selectedAuthenticatedUser',
    ],
    setIsLoadingAuthenticatedUsers: ['isLoadingAuthenticatedUsers'],
  },
  { prefix: '@BE-USER/' },
);

export const UserActions = Creators;
export const UserTypes = Types;

export const INITIAL_STATE = Immutable({
  isChangePasswordLoading: false,
  isCreateUserLoading: false,
  changePasswordOk: null,
  createUserOk: null,
  organizations: [],
  isOrganizationsLoading: false,
  isUsersLoading: false,
  errors: [],
  tags: {},
  areTagsLoading: false,
  selectedAuthenticatedUser: DefaultUser,
  authenticatedUsers: [],
});

export const UserSelectors = {
  // TODO: Rename selectors to select{Data}, per https://redux.js.org/style-guide/#name-selector-functions-as-selectthing
  getChangePasswordLoading: ({ user }) => user.isChangePasswordLoading,
  getCreateUserLoading: ({ user }) => user.isCreateUserLoading,
  getChangePasswordOk: ({ user }) => user.changePasswordOk,
  getCreateUserOk: ({ user }) => user.createUserOk,
  getOrganizations: ({ user }) => user.organizations,
  getOrganizationsOptions: ({ user }) => [
    ...user.organizations.map((org, i) => ({
      value: org.id,
      label: org.name,
      key: i + 1,
    })),
  ],
  getOrganizationsLoading: ({ user }) => user.isOrganizationsLoading,
  getUsersLoading: ({ user }) => user.isUsersLoading,
  getTags: ({ user }) => user.tags,
  getAreTagsLoading: ({ user }) => user.areTagsLoading,
  getCriticalUserErrors: ({ user }) => user.errors.find((error) => error?.unauthorized),
  selectAuthenticatedUser: ({ user }) => user.authenticatedUsers.find(({ current }) => current),
  selectAuthenticatedUsers: ({ user }) => user.authenticatedUsers,
  selectIsLoadingAuthenticatedUsers: ({ user }) => user.isLoadingAuthenticatedUsers,
};

/* ------------- REDUCERS ACTIONS ------------------- */
const fetchOrganizationsSuccess = (state, { organizations }) => state.merge({ organizations });

const setOrganizationsLoading = (state, { isOrganizationsLoading }) => state.merge({ isOrganizationsLoading });

const setUsersIsLoading = (state, { isUsersLoading }) => state.merge({ isUsersLoading });

const setChangePasswordLoading = (state, { isChangePasswordLoading }) => state.merge({ isChangePasswordLoading });

const setCreateUserLoading = (state, { isCreateUserLoading }) => state.merge({ isCreateUserLoading });

const setChangePasswordOk = (state, { changePasswordOk }) => state.merge({ changePasswordOk });

const setCreateUserOk = (state, { createUserOk }) => state.merge({ createUserOk });

const setUserErrors = (state, { error }) => state.merge({
  errors: state.errors.concat(error),
});

const fetchTagsSuccess = (state, { tags }) => state.merge({ tags });

const fetchAuthenticatedUsersSuccess = (
  state,
  { authenticatedUsers, selectedAuthenticatedUser },
) => state.merge({ authenticatedUsers, selectedAuthenticatedUser });

const setIsLoadingAuthenticatedUsers = (
  state,
  { isLoadingAuthenticatedUsers },
) => state.merge({ isLoadingAuthenticatedUsers });

const setAuthenticatedUserSuccess = (
  state,
  { authenticatedUser },
) => {
  // Set the correct user as current true and set current false for all others
  const newAuthenticatedUsers = state.authenticatedUsers.map((existingAuthenticatedUser) => ({
    ...existingAuthenticatedUser,
    current: (existingAuthenticatedUser.id === authenticatedUser.id),
  }));
  return state.merge({ authenticatedUsers: newAuthenticatedUsers });
};

export const UserReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_ORGANIZATIONS_SUCCESS]: fetchOrganizationsSuccess,
  [Types.SET_ORGANIZATIONS_LOADING]: setOrganizationsLoading,
  [Types.SET_CHANGE_PASSWORD_LOADING]: setChangePasswordLoading,
  [Types.SET_CREATE_USER_LOADING]: setCreateUserLoading,
  [Types.SET_CHANGE_PASSWORD_OK]: setChangePasswordOk,
  [Types.SET_CREATE_USER_OK]: setCreateUserOk,
  [Types.SET_USER_ERRORS]: setUserErrors,
  [Types.FETCH_TAGS_SUCCESS]: fetchTagsSuccess,
  [Types.SET_USERS_IS_LOADING]: setUsersIsLoading,
  [Types.FETCH_AUTHENTICATED_USERS_SUCCESS]: fetchAuthenticatedUsersSuccess,
  [Types.SET_AUTHENTICATED_USER_SUCCESS]: setAuthenticatedUserSuccess,
  [Types.SET_IS_LOADING_AUTHENTICATED_USERS]: setIsLoadingAuthenticatedUsers,
});
